import { render, staticRenderFns } from "./Magazine.vue?vue&type=template&id=44c43c76&scoped=true"
import script from "./Magazine.vue?vue&type=script&lang=js"
export * from "./Magazine.vue?vue&type=script&lang=js"
import style0 from "./Magazine.vue?vue&type=style&index=0&id=44c43c76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c43c76",
  null
  
)

export default component.exports